import { Component } from '@angular/core';
import { App, NavController } from "ionic-angular";
import { AuthService } from "../../../services/auth.service";
import { EventService } from '../../../services/event.service';

@Component({
  selector: 'user-navigation',
  templateUrl: 'user-navigation.html'
})

export class UserNavigation {

  constructor(public authService: AuthService,
              public eventService: EventService) {


  }

}



// WEBPACK FOOTER //
// ./src/partials/user/user-navigation/user-navigation.ts